import { ChevronDownIcon } from 'lucide-react';
import * as React from 'react';

import { cn } from '../utils';

export const dropdownTriggerStyles =
  "border-input text-foreground data-[placeholder]:text-muted-foreground focus-visible:ring-ring aria-[invalid=true]:ring-destructive/20 dark:aria-[invalid=true]:ring-destructive/40 aria-[invalid=true]:border-destructive dark:bg-input/30 dark:hover:bg-input/50 flex h-12 w-full items-center justify-between gap-2 rounded-sm border bg-transparent px-3 py-2 text-sm whitespace-nowrap shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4";

export const dropdownContentStyles =
  'bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 relative z-50 overflow-hidden rounded-sm border border-border shadow-md';

interface DropdownShellTriggerProps
  extends Omit<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    'aria-label' | 'id' | 'type'
  > {
  id: string;
  'aria-label': string;
}

export const DropdownShellTrigger = React.forwardRef<
  HTMLButtonElement,
  DropdownShellTriggerProps
>(({ className, children, ...props }, ref) => {
  return (
    <button
      ref={ref}
      type="button"
      data-testid={props.id}
      className={cn(dropdownTriggerStyles, className)}
      {...props}
    >
      {children}
      <ChevronDownIcon className="size-4 pointer-events-none" />
    </button>
  );
});

DropdownShellTrigger.displayName = 'DropdownShellTrigger';
